import { __awaiter, __generator } from "tslib";
export var createBaseTableHeadCellDriver = function (wrapper) {
    var base = wrapper.hasClass('table-head-cell')
        .then(function (val) { return val ? wrapper : wrapper.$('.table-head-cell'); });
    return {
        click: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, base];
                case 1: return [2 /*return*/, (_a.sent()).click()];
            }
        }); }); },
        hasClass: function (name) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, base];
                case 1: return [2 /*return*/, (_a.sent()).hasClass(name)];
            }
        }); }); }
    };
};
//# sourceMappingURL=driver.js.map